import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

/**
 * Uniform variable for boolean types.
 */
export class UniformBoolean extends Uniform {
    constructor(name: string) {
        super(name);
    }

    loadBoolean(value: boolean) {
        if (this.location) {
            gl.uniform1i(this.location, value ? 1 : 0);
        }
    }
}
